import { useEffect, useRef, useState } from "react";

interface Props {
  title: string;
  label: string;
  initialValue: string;
  placeholder?: string;
  /** datalist 補完 */
  suggestions?: string[];
  /** 保存時に値の検証(空文字でエラーメッセージを返す = OK、文字列を返す = エラー) */
  validate?: (value: string) => string | null;
  onSave: (value: string) => void;
  onCancel: () => void;
}

export function TextInputModal({
  title,
  label,
  initialValue,
  placeholder,
  suggestions,
  validate,
  onSave,
  onCancel,
}: Props) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  const save = () => {
    const v = value.trim();
    if (!v) {
      setError("空欄では保存できません");
      return;
    }
    if (validate) {
      const err = validate(v);
      if (err) {
        setError(err);
        return;
      }
    }
    onSave(v);
  };

  const listId = suggestions ? `text-input-suggest-${title.replace(/\s+/g, "_")}` : undefined;

  return (
    <div className="modal-backdrop" onMouseDown={onCancel}>
      <div className="modal modal-text-input" onMouseDown={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        <label className="text-input-label">
          {label}
          <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError(null);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                save();
              }
            }}
            placeholder={placeholder}
            list={listId}
          />
        </label>
        {suggestions && listId && (
          <datalist id={listId}>
            {suggestions.map((s) => (
              <option key={s} value={s} />
            ))}
          </datalist>
        )}
        {error && <div className="text-input-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            キャンセル
          </button>
          <button className="btn btn-primary" onClick={save}>
            保存
          </button>
        </div>
      </div>
    </div>
  );
}
